export default "__VITE_ASSET__Cot$Tbkw__"